<!-- <div class="row" *ngIf="attachmentsArr">
	<div *ngFor="let atc of attachmentsArr" class="col-sm-4 p-1">
		<div class="card">
			<div class="row">
				<div class="col-sm-4 p-3" style="overflow-x: hidden;">
					<a id="otherFile" matTooltip="{{getName(atc.name)}}" href="{{atc.url}}" target="_blank">
						<fa-icon *ngIf="!showAttachmentImage(atc.url)" style="font-size:42px;color:blue"
							[icon]="['fas', 'file']"></fa-icon>
						<img *ngIf="showAttachmentImage(atc.url)" src="{{atc.url}}" style="width: 36px;height: 42px;" />
					</a>
				</div>
				<div class="col-sm-8 p-1" style="overflow-x: hidden;">
					<span class="ms-1">{{getName(atc.name) | limitTo:"20"}}</span>
				</div>
			</div>
		</div>
	</div>
</div> -->
@if (attachmentsArr) {
<div class="attachments-container d-flex flex-wrap">
	@for (atc of attachmentsArr; track $index) {
	<div class="attachment d-flex align-items-center position-relative p-2 border rounded m-1">
		<a [matTooltip]="getName(atc.name)" href="{{atc.url}}" target="_blank">
			<img [src]="isImage(atc.name)?atc.url:defaultIcon" alt="{{getShortName(atc.name)}}"
				class="attachment-thumb me-2" />
		</a>
		<div class="text-truncate d-inline-block" [matTooltip]="getName(atc.name)">
			{{getName(atc.name)}}
		</div>
		@if (atc.apptId) {
		<fa-icon [icon]="['fas','file']" class="position-absolute top-0 m-1 text-primary corner-icon"
			[ngClass]="showDelete?'end-11':'end-0'" matTooltip="Report File">
		</fa-icon>
		}
		@if (showDelete) {
		<fa-icon [icon]="['fas','times']" class="position-absolute top-0 end-0 m-1 text-secondary corner-icon c-pointer"
			(click)="removeAttachment(atc)" matTooltip="Remove">
		</fa-icon>
		}
	</div>
	}
</div>
}